
import { t } from "@/locales";
/**
 * 列のすべての内容を巡回し、最も広い列の幅を取得する
 * @param arr
 */
export function  getMaxLength(arr) {
    return arr.reduce((acc, item) => {
      if (item) {
        const calcLen = getTextWidth(item);
        if (acc < calcLen) {
          acc = calcLen;
        }
      }
      return acc;
    }, 0);
}

/**
 * spanラベルを使用してコンテンツをラップし、spanの幅width:pxを計算します
 * @param valArr
 */
export function getTextWidth(str) {
  let width = 0;
  const html = document.createElement("span");
  html.innerText = str;
  html.className = "getTextWidth";
  document.querySelector("body").appendChild(html);
  width = document.querySelector(".getTextWidth").offsetWidth;
  document.querySelector(".getTextWidth").remove();
  return width;
}

/**
 * el-table-column アダプティブ列幅
 * @param prop_label: 表名
 * @param table_data: 表データ
 */
export function flexColumnWidth(label, prop, tableData) {

  var innerWidth = parseInt(t('widgetSize.tableCommon.commonAddWidth'));

  if (label === "受注") {
    innerWidth = parseInt(t('widgetSize.tableCommon.orderCheckedAddWidth'));
  }

  if (label === "小計") {
    innerWidth = parseInt(t('widgetSize.COMMON_CONSTANT.TOTAL_COLUMN_WIDTH'));
  }

  if (label === "備考") {
    innerWidth = parseInt(t('widgetSize.tableCommon.colMaxWidth'));
  }

  var arr = [];

 if (tableData != null && tableData.map != null) {
    // 1.データを取得する
    arr = tableData.map((x) => x[prop]);
    arr.push(label); // 表の頭も入れて計算する
  } else {
    arr.push(label);//　データが空の場合、配列にlabelを追加
  }

  var width = getMaxLength(arr) + innerWidth;
  const maxWidth = parseInt(t('widgetSize.tableCommon.colMaxWidth'));

  if (width > maxWidth) {
    width = maxWidth;
  }
  // 2.各列の内容の最大幅+表の内側間隔を計算する
  return width + "px";
}

export function setColumnWidth(columns, tableData) {


  for (let index = 0; index < columns.length; index++) {
    const element = columns[index];
    columns[index].width = flexColumnWidth(
      element.label,
      element.prop,
      tableData
    );
  }
}
